import { loadMapSettings } from "../../apis/maps";
import { atomWithQuery } from "jotai-tanstack-query";

export const mapSettingsAtom = atomWithQuery(() => ({
  queryKey: ["mapSettings"],
  queryFn: async () => {
    return loadMapSettings();
  },
}));
